import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import utc from "dayjs/plugin/utc";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, FormHelperText, Grid, Stack, Typography } from "@mui/material";
import AddEventStyle from "./AddEventStyle";
import ButtonComponent from "../../../components/button/ButtonComponent";
import AddEventValidationSchema from "./AddEventValidationSchema";
import Breadcrumb from "../../../components/breadCrumb/Breadcrumb";
import { addHoursToTime, eventDateConveter, isTimeInRange, isTimeInSlot } from "../../../utils/helper";
import DatePickerComponent from "../../../components/datePicker/DatePickerComponent";
import TimePickerComponent from "../../../components/datePicker/TimePickerComponent";
import InputFieldComponent from "../../../components/inputField/InputFieldComponent";
import SelectDropdown from "../../../components/selectDropdown/SelectDropdown";
import ModalComponents from '../../../components/modalComponents/ModalComponents'
import AddVenueModal from "../../../modals/addVenue/AddVenueModal";
import { useTranslation } from "react-i18next";
import i18n from "../../../translation/translations";
dayjs.extend(utc);

const AddEvent = () => {
  const navigateTo = useNavigate();
  const { t } = useTranslation()
  const currentLanguage = localStorage.getItem("language")
  const isEventEdit = "";
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const eventId = searchParams?.get("editId")
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedVenueInfo, setSelectedVenueInfo] = useState<any>();
  const [seletedEvent, setSelectedEvent] = useState<AllEvents>()
  const [addVenueModalOpen, setAddVenueModalOpen] = useState<boolean>(false)
  const [venueList, setVenueList] = useState<Venue[]>([])
  const [venueListDropdown, setVenueListDropdown] = useState<BookingType[]>([])

  useEffect(() => {
    //Fetch all the events
    fetchVenue();
  }, []);

  useEffect(() => {
    // Set language when user refresh the page
    if (currentLanguage === "spanish") {
      i18n.changeLanguage("sp");
    } else {
      i18n.changeLanguage("en");
    }
  }, [currentLanguage])

  useEffect(() => {
    const editableEvent = venueList.find((venue: Venue) => venue.name === seletedEvent?.venue)
    setSelectedVenueInfo(editableEvent)
  }, [venueList, seletedEvent])


  useEffect(() => {
    if (eventId) {
      setIsEditable(true)
      try {
        const fetchData = async () => {
          const response = await axios.get(`http://localhost:4200/eventsData/${eventId}`);
          if (response.data) {
            setSelectedEvent(response.data)
          }
        };
        fetchData();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }, [eventId]);

  const fetchVenue = async () => {
    try {
      let createVenue: BookingType[] = [];
      const response = await axios.get("http://localhost:4200/venue");
      if (response.data) {
        setVenueList(response.data);
        response?.data?.map((venue: Venue) => {
          return (
            createVenue.push({
              label: venue?.name,
              value: venue?.name,
            })
          )
        });
      }
      setVenueListDropdown(createVenue)
    } catch (error) {
      console.log("Error fetching venue data:", error);
    }
  };

  const initialValues = {
    name: seletedEvent?.name || "",
    title: seletedEvent?.title || "",
    aboutEvent: seletedEvent?.aboutEvent || "",
    venue: seletedEvent?.venue || "",
    startDate:
      (seletedEvent && dayjs(seletedEvent?.start).format("YYYY-MM-DD")) || "",
    endDate:
      (seletedEvent && dayjs(seletedEvent?.end).format("YYYY-MM-DD")) || "",
    startTime:
      (seletedEvent && dayjs(seletedEvent?.start).format("YYYY-MM-DD HH:mm")) ||
      "",
    endTime:
      (seletedEvent && dayjs(seletedEvent?.end).format("YYYY-MM-DD HH:mm")) ||
      "",
  };

  const eventDetailFormik = useFormik({
    initialValues,
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    validationSchema: AddEventValidationSchema(),
    onSubmit: async (values) => {
      setIsLoading(true);
      const { startDate, endDate, startTime, endTime, ...rest } = values;
      const start = `${startDate} ${dayjs(startTime).format("HH:mm")}`;
      const end = `${endDate} ${dayjs(endTime).format("HH:mm")}`;
      const data = eventDateConveter(start, end)
      const payloads = data.map((item: AddData) => ({
        ...rest,
        start: item.start_event,
        end: item.end_event,
        id: uuidv4()
      }));
      try {
        if (isEditable) {
          // Update event
          for (const payload of payloads) {
            const response = await axios.put(`http://localhost:4200/eventsData/${eventId}`, payload);
            if (response.status === 200) {
              toast.success(t("toastMsg.eventUpdate"))
            } else {
              console.error("error", response.status);
            }
          }
        } else {
          // Create event
          let successCount = 0;
          for (const payload of payloads) {
            const response = await axios.post("http://localhost:4200/eventsData", payload);
            if (response.status === 201) {
              successCount++;
            } else {
              console.error("error", response.status);
            }
          }
          if (payloads.length === 1) {
            toast.success(t("toastMsg.eventAdded"));
          } else if (successCount === payloads.length) {
            toast.success(t("toastMsg.allEventAdded"));
          }
        }
        setIsLoading(false);
        navigateTo('/');
      } catch (error) {
        console.error("error", error);
        setIsLoading(false);
      }
    },
  });

  const handleAddVenue = () => {
    setAddVenueModalOpen(true)
  }

  const selectedStartTime = dayjs(eventDetailFormik.values.startTime).format(
    "HH:mm"
  );


  return (
    <>
      <Box {...(!isEventEdit && AddEventStyle.productDetailsBox)}>
        <Breadcrumb
          onHomePress={() => navigateTo("/")}
          pathList={[
            {
              label: t("homePage.calendar"),
              href: "http://localhost:3000",
            },
            { label: t("homePage.addEvent") },
          ]}
        />
        <form
          onSubmit={eventDetailFormik.handleSubmit}
          style={{ marginTop: "30px" }}
        >
          <Grid container {...AddEventStyle.productDetailsGrid}>
            <Grid
              item
              {...(!isEventEdit
                ? { sm: 12, md: 8, lg: 6, width: "100%" }
                : { xs: 12 })}
              className="tab-mobile-wrap tab-mobile-wrap-table"
            >

              <Stack spacing={2}>
                <InputFieldComponent
                  label={t("addEventPage.name")}
                  {...eventDetailFormik.getFieldProps("name")}
                  error={
                    eventDetailFormik.touched.name &&
                    Boolean(eventDetailFormik.errors.name)
                  }
                  helperText={
                    (!isEventEdit &&
                      eventDetailFormik.touched.name &&
                      eventDetailFormik.errors.name) ||
                    (isEventEdit && eventDetailFormik.errors.name)
                  }
                  placeHolder=""
                />
                <InputFieldComponent
                  label={t("addEventPage.title")}
                  labelSmall={t("addEventPage.subTitle")}
                  {...eventDetailFormik.getFieldProps("title")}
                  error={
                    eventDetailFormik.touched.title &&
                    Boolean(eventDetailFormik.errors.title)
                  }
                  helperText={
                    (!isEventEdit &&
                      eventDetailFormik.touched.title &&
                      eventDetailFormik.errors.title) ||
                    (isEventEdit && eventDetailFormik.errors.title)
                  }
                  placeHolder=""
                />
                <InputFieldComponent
                  label={t("addEventPage.aboutEvent")}
                  multiLine={true}
                  rows={4}
                  {...eventDetailFormik.getFieldProps("aboutEvent")}
                  error={
                    eventDetailFormik.touched.aboutEvent &&
                    Boolean(eventDetailFormik.errors.aboutEvent)
                  }
                  helperText={
                    eventDetailFormik.touched.aboutEvent &&
                    eventDetailFormik.errors.aboutEvent
                  }
                  placeHolder=""
                />
                <SelectDropdown
                  handleAddVenue={handleAddVenue}
                  label={t("addEventPage.venue")}
                  optionsData={venueListDropdown}
                  placeholder=""
                  isSearchable={false}
                  name="venue"
                  onChange={(valuesSelect) => {
                    eventDetailFormik.setFieldValue(
                      "venue",
                      valuesSelect.value
                    );
                    if (valuesSelect.label) {
                      const selectedVenue = venueList.find((venue: Venue) => venue.name === valuesSelect.label)
                      setSelectedVenueInfo(selectedVenue);
                      eventDetailFormik.setFieldValue("startDate", "");
                      eventDetailFormik.setFieldValue("startTime", "");
                      eventDetailFormik.setFieldValue("endDate", "");
                      eventDetailFormik.setFieldValue("endTime", "");
                    }
                  }}
                  error={
                    eventDetailFormik.touched.venue &&
                    Boolean(eventDetailFormik.errors.venue)
                  }
                  helperText={
                    eventDetailFormik.touched.venue &&
                    eventDetailFormik.errors.venue
                  }
                  value={venueListDropdown?.find(
                    (selected: { value: { toString: () => string } }) =>
                      selected?.value?.toString()?.toLocaleLowerCase() ===
                      eventDetailFormik?.values?.venue
                        ?.toString()
                        ?.toLocaleLowerCase()
                  )}
                />
                {selectedVenueInfo && <Typography {...AddEventStyle.infoText}>
                  {t("addVenueModal.slotMessage", {
                    startTime: selectedVenueInfo.start_time,
                    endTime: selectedVenueInfo.end_time,
                    bookingHours: selectedVenueInfo.maxHourPerBooking
                  })}
                </Typography>}
                <Stack
                  {...{
                    ...AddEventStyle.mainStack,
                  }}
                >
                  <Grid item xs={12} sm={12} lg={6}>
                    <DatePickerComponent
                      minDate={dayjs()}
                      shouldDisableDate={() =>
                        !eventDetailFormik?.values?.venue
                      }
                      onOpen={() => {
                        if (!eventDetailFormik?.values?.venue) {
                          toast.error(t("toastMsg.selectVenue"))
                        }
                      }}
                      name="startDate"
                      labelText={t("addEventPage.startDate")}
                      value={
                        (eventDetailFormik.values?.startDate
                          ? dayjs(eventDetailFormik.values?.startDate)
                          : null) as any
                      }
                      onChange={(option) => {
                        if (option) {
                          eventDetailFormik.setFieldValue(
                            "startDate",
                            option.format("YYYY-MM-DD")
                          );
                          eventDetailFormik.setFieldValue("endDate", "");
                          eventDetailFormik.setFieldValue("startTime", "");
                          eventDetailFormik.setFieldValue("endTime", "");
                        }
                      }}
                    />
                    {eventDetailFormik.touched.startDate &&
                      (Boolean(eventDetailFormik.errors.startDate) ? (
                        <FormHelperText
                          {...AddEventStyle.startDateFormHelperText}
                        >
                          {eventDetailFormik.errors.startDate
                            ? eventDetailFormik.errors.startDate.toString()
                            : null}
                        </FormHelperText>
                      ) : null)}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    lg={6}
                    {...AddEventStyle.radioStackGrid}
                  >
                    <TimePickerComponent
                      labelText={t("addEventPage.startTime")}
                      disabled={!moment().toString()}
                      name="startTime"
                      value={
                        eventDetailFormik.values?.startTime
                          ? dayjs(eventDetailFormik.values?.startTime)
                          : null
                      }
                      onOpen={() => {
                        if (!eventDetailFormik?.values?.startDate) {
                          toast.error(t("toastMsg.selectStartDate"));
                        }
                      }}
                      shouldDisableTime={() =>
                        !eventDetailFormik?.values?.startDate
                      }
                      onChange={(option) => {
                        const selectedTime = option?.format("HH:mm");
                        if (option && option.isValid()) {
                          if (
                            isTimeInRange(
                              selectedVenueInfo?.start_time,
                              selectedVenueInfo?.end_time,
                              selectedTime,
                              "startTime"
                            )
                          ) {
                            eventDetailFormik.setFieldValue(
                              "startTime",
                              `${eventDetailFormik?.values?.startDate
                              } ${option.format("HH:mm")}`
                            );
                            eventDetailFormik.setFieldValue("endDate", "");
                            eventDetailFormik.setFieldValue("endTime", "");
                            setIsSubmitDisabled(false);
                          } else {
                            setIsSubmitDisabled(true);
                            eventDetailFormik.setFieldValue("startTime", "");
                            toast.error(t("addVenueModal.startTimeRange", {
                              startTime: selectedVenueInfo.start_time,
                              endTime: selectedVenueInfo.end_time,
                            }))
                          }
                        }
                      }}
                      disableIgnoringDatePartForTimeValidation
                    />
                    {eventDetailFormik.touched.startTime &&
                      (Boolean(eventDetailFormik.errors.startTime) ? (
                        <FormHelperText
                          {...AddEventStyle.startDateFormHelperText}
                        >
                          {eventDetailFormik.errors.startTime
                            ? eventDetailFormik.errors.startTime.toString()
                            : null}
                        </FormHelperText>
                      ) : null)}
                  </Grid>
                </Stack>
                <Stack {...AddEventStyle.radioGroupWrap}>
                  <Grid item md={12} xs={12} sm={12} lg={12}>
                    <DatePickerComponent
                      shouldDisableDate={() =>
                        !eventDetailFormik?.values?.startDate ||
                        !eventDetailFormik?.values?.startTime
                      }
                      onOpen={() => {
                        if (
                          !eventDetailFormik?.values?.startDate ||
                          !eventDetailFormik?.values?.startTime
                        ) {
                          toast.error(t("toastMsg.selectStartDateTime"));
                        }
                      }}
                      minDate={dayjs(eventDetailFormik?.values?.startDate)}
                      maxDate={
                        selectedVenueInfo && selectedVenueInfo?.bookingType === "Single Booking"
                          ? addHoursToTime(
                            eventDetailFormik?.values?.startDate,
                            selectedVenueInfo?.start_time,
                            selectedVenueInfo?.maxHourPerBooking
                          )
                          : null
                      }
                      name="endDate"
                      labelText={t("addEventPage.endDate")}
                      value={
                        (eventDetailFormik.values?.endDate
                          ? dayjs(eventDetailFormik.values?.endDate)
                          : null) as any
                      }
                      onChange={(option) => {
                        if (option) {
                          eventDetailFormik.setFieldValue(
                            "endDate",
                            option.format("YYYY-MM-DD")
                          );
                          eventDetailFormik.setFieldValue("endTime", "");
                        }
                      }}
                    />

                    {eventDetailFormik.touched.endDate &&
                      eventDetailFormik.touched.endDate &&
                      (Boolean(eventDetailFormik.errors.endDate) ? (
                        <FormHelperText
                          {...AddEventStyle.startDateFormHelperText}
                        >
                          {eventDetailFormik.errors.endDate
                            ? eventDetailFormik.errors.endDate.toString()
                            : null}
                        </FormHelperText>
                      ) : null)}
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    sm={12}
                    lg={12}
                    {...AddEventStyle.radioStackGrid}
                  >
                    <TimePickerComponent
                      labelText={t("addEventPage.endTime")}
                      disabled={!moment().toString()}
                      shouldDisableTime={() =>
                        !eventDetailFormik?.values?.endDate
                      }
                      name="endTime"
                      value={
                        eventDetailFormik.values?.endTime
                          ? dayjs(eventDetailFormik.values?.endTime)
                          : null
                      }
                      onOpen={() => {
                        if (!eventDetailFormik?.values?.endDate) {
                          toast.error(t("toastMsg.selectEndDate"));
                        }
                      }}
                      onChange={(option) => {
                        const selectedTime = option?.format("HH:mm");
                        const { start_time, end_time, maxHourPerBooking } = selectedVenueInfo;
                        if (option && option.isValid()) {
                          if (
                            isTimeInRange(
                              start_time,
                              end_time,
                              selectedTime,
                              "endTime",
                              eventDetailFormik.values?.endDate,
                              addHoursToTime(
                                eventDetailFormik?.values?.startDate,
                                selectedVenueInfo?.start_time,
                                maxHourPerBooking
                              ),
                              selectedVenueInfo?.booking_type,
                              eventDetailFormik?.values?.startTime
                            )
                          ) {
                            if (
                              isTimeInSlot(
                                selectedStartTime,
                                selectedTime,
                                maxHourPerBooking,
                                eventDetailFormik?.values?.startTime,
                                eventDetailFormik?.values?.endDate,
                                selectedVenueInfo?.start_time,
                                selectedVenueInfo?.end_time
                              )
                            ) {
                              eventDetailFormik.setFieldValue(
                                "endTime",
                                `${eventDetailFormik?.values?.endDate
                                } ${option.format("HH:mm")}`
                              );
                              setIsSubmitDisabled(false);
                            } else {
                              toast.error(t("addVenueModal.selectSlotForHrs", {
                                maxHoursPerBooking: maxHourPerBooking
                              }))
                              setIsSubmitDisabled(true);
                            }
                          } else {
                            setIsSubmitDisabled(true);
                            toast.error(t("addVenueModal.startTimeRange", {
                              startTime: start_time,
                              endTime: end_time,
                            }))
                          }
                        }
                        if (dayjs(eventDetailFormik?.values?.startTime).format("HH:mm") === option?.format("HH:mm")) {
                          setIsSubmitDisabled(true)
                          toast.error(t("toastMsg.sameTime"))
                        }
                      }}
                      disableIgnoringDatePartForTimeValidation
                    />
                    {eventDetailFormik.touched.endTime &&
                      (Boolean(eventDetailFormik.errors.endTime) ? (
                        <FormHelperText
                          {...AddEventStyle.startDateFormHelperText}
                        >
                          {eventDetailFormik.errors.endTime
                            ? eventDetailFormik.errors.endTime.toString()
                            : null}
                        </FormHelperText>
                      ) : null)}
                  </Grid>
                </Stack>
              </Stack>
              <Box sx={{
                ...AddEventStyle.buttonStylesBox,
              }}>
                <ButtonComponent
                  text={t("btnText.cancel")}
                  variant="outlined"
                  sx={{
                    ...AddEventStyle.promoCodeModelBtnCancelSx,
                  }}
                  onClick={() => navigateTo('/')}
                />
                <ButtonComponent
                  text={t("btnText.save")}
                  sx={{
                    ...AddEventStyle.productDetailsSaveBtnSx,
                  }}
                  disabled={isSubmitDisabled || isLoading}
                  type="submit"
                />
              </Box>
            </Grid>
          </Grid>
        </form>
        <ModalComponents
          open={addVenueModalOpen}
          title={t("addVenueModal.addVenue")}
        >
          <AddVenueModal
            handleClose={() => setAddVenueModalOpen(false)}
            fetchVenue={fetchVenue}
          />
        </ModalComponents>
      </Box >
    </>
  );
};

export default AddEvent;
